module.exports = __webpack_public_path__ + "static/yog-technique-1f2dd4d4530ba93c3de6754f43badfa3.svg";